import React, { useEffect, useRef, useState } from 'react';

/**
 * Selettore cliente a card orizzontali (stile Marketing Analytics).
 * Props:
 *  - clienti: [{ id, nome, azienda, logo_url }]
 *  - selected: id del cliente attivo
 *  - onSelect: (cliente) => void
 *  - label: intestazione (default "Cliente")
 *  - badge: (cliente) => nodo facoltativo accanto al nome (es. contenuti mancanti)
 */
export default function ClientePicker({ clienti = [], selected, onSelect, label = 'Cliente', badge }) {
  const rowRef = useRef(null);
  const [logoKo, setLogoKo] = useState({});   // loghi che non si caricano → iniziale
  // Il cliente scelto resta sempre in vista, anche se è in fondo alla fila.
  useEffect(() => {
    const el = rowRef.current?.querySelector('[aria-selected="true"]');
    if (el) el.scrollIntoView({ block: 'nearest', inline: 'center' });
  }, [selected, clienti.length]);
  if (!clienti.length) return null;
  return (
    <div style={{ marginBottom: 18 }}>
      <div ref={rowRef} className="eden-scroll-row" role="listbox" aria-label={label} style={{ gap: 8, paddingBottom: 2 }}>
        {clienti.map(c => {
          const sel = c.id === selected;
          const nome = c.azienda || c.nome || '?';
          return (
            <button key={c.id} onClick={() => onSelect(c)} role="option" aria-selected={sel} title={nome}
              style={{
                display: 'flex', alignItems: 'center', gap: 9, height: 44, minHeight: 0, padding: '0 14px 0 6px',
                borderRadius: 999, cursor: 'pointer', flexShrink: 0, fontFamily: 'inherit',
                border: `1px solid ${sel ? 'var(--cyan)' : 'var(--border)'}`,
                background: sel ? 'var(--cyan-dim)' : 'var(--surface)',
                transition: 'background 0.15s, border-color 0.15s',
              }}>
              <span style={{
                width: 32, height: 32, borderRadius: '50%', flexShrink: 0, overflow: 'hidden',
                background: c.logo_url ? 'var(--bg3)' : 'var(--bg3)', color: sel ? 'var(--cyan)' : 'var(--text-muted)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700,
                border: '1px solid var(--border)',
              }}>
                {c.logo_url && !logoKo[c.id]
                  ? <img src={c.logo_url} alt="" onError={() => setLogoKo(k => ({ ...k, [c.id]: true }))} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  : nome.trim().charAt(0).toUpperCase()}
              </span>
              <span style={{ fontSize: 13.5, fontWeight: 600, color: sel ? 'var(--text)' : 'var(--text-muted)', whiteSpace: 'nowrap' }}>{nome}</span>
              {badge && badge(c)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
